/* eslint-disable no-console */
import Button from './button/Button';
import ContentHeader from './content-header/ContentHeader';
import PageLoading from './page-loading/PageLoading';
import SmallBox from './small-box/SmallBox';

console.log(SmallBox);

export {Button, ContentHeader, PageLoading, SmallBox};
